import React, { useState } from 'react';
import ONCRP_TOOLS_QP_Card from './OncoRiskCard';

const TherapeuticImplicationsCard = ({ therapeuticImplications }) => {
    const [expandedOncoKbRow, setExpandedOncoKbRow] = useState(null);
    
    if (!therapeuticImplications) return null;

    const { oncokb_fda_approved_treatments, civic_literature_evidence } = therapeuticImplications;

    const handleOncoKbRowClick = (index) => {
        setExpandedOncoKbRow(expandedOncoKbRow === index ? null : index);
    };

    return (
        <ONCRP_TOOLS_QP_Card title="Therapeutic Implications" icon="fa-pills" className="ONCRP-TOOLS-QP-span-col-6">
            <div className="ONCRP-TOOLS-QP-subsection">
                <h4>FDA-Approved Therapies (OncoKB) <small>(Click row for details)</small></h4>
                <div className="ONCRP-TOOLS-QP-table-container">
                    <table>
                        <thead><tr><th>Drug(s)</th><th>Cancer Type</th><th>Level</th></tr></thead>
                        <tbody>
                            {oncokb_fda_approved_treatments?.map((item, i) => (
                                <React.Fragment key={`onco-${i}`}>
                                    <tr onClick={() => handleOncoKbRowClick(i)} style={{cursor: 'pointer'}}>
                                        <td>{item.drugs}</td>
                                        <td>{item.cancerType}</td>
                                        <td><span className={`ONCRP-TOOLS-QP-level-tag ONCRP-TOOLS-QP-level-${item.level}`}>{item.level}</span></td>
                                    </tr>
                                    {expandedOncoKbRow === i && (
                                        <tr className="ONCRP-TOOLS-QP-details-row"><td colSpan="3">{item.fdaApproval}</td></tr>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="ONCRP-TOOLS-QP-section">
                <h4>Literature Evidence (CIViC)</h4>
                <div className="ONCRP-TOOLS-QP-table-container">
                    <table>
                        <thead><tr><th>Drug(s)</th><th>Disease</th><th>Type</th><th>Direction</th><th>Lvl</th><th>Rating</th><th>Source</th></tr></thead>
                        <tbody>
                            {civic_literature_evidence?.map((item, i) => (
                                <tr key={`civic-${i}`}>
                                    <td>{Array.isArray(item.drugs) ? item.drugs.join(', ') || 'N/A' : (item.drugs || 'N/A')}</td>
                                    <td>{item.disease}</td>
                                    <td><span className="ONCRP-TOOLS-QP-tag">{item.evidence_type?.replace(/_/g, ' ')}</span></td>
                                    <td><span className={`ONCRP-TOOLS-QP-tag ONCRP-TOOLS-QP-tag-direction`}>{item.evidence_direction}</span></td>
                                    <td><span className={`ONCRP-TOOLS-QP-level-tag ONCRP-TOOLS-QP-level-civic-${item.evidence_level}`}>{item.evidence_level || 'N/A'}</span></td>
                                    <td>{item.evidence_rating !== 'N/A' ? '★'.repeat(Number(item.evidence_rating)) + '☆'.repeat(5 - Number(item.evidence_rating)) : 'N/A'}</td>
                                    <td>{item.pubmed_id ? <a href={`https://pubmed.ncbi.nlm.nih.gov/${item.pubmed_id}`} target="_blank" rel="noopener noreferrer">PMID:{item.pubmed_id}</a> : 'N/A'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </ONCRP_TOOLS_QP_Card>
    );
};

export default TherapeuticImplicationsCard; 